import { render, staticRenderFns } from "./AddTemDoctor.vue?vue&type=template&id=4f69288b&scoped=true"
import script from "./AddTemDoctor.vue?vue&type=script&lang=js"
export * from "./AddTemDoctor.vue?vue&type=script&lang=js"
import style0 from "./AddTemDoctor.vue?vue&type=style&index=0&id=4f69288b&prod&lang=scss&scoped=true"
import style1 from "./AddTemDoctor.vue?vue&type=style&index=1&id=4f69288b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f69288b",
  null
  
)

export default component.exports